<template>
  <div class="orders-operation float-right">
    <span class="mr-3">
      <span v-if="selectedIds.length">
        <button
          type="button"
          class="btn btn-sm btn-primary mx-2"
          v-on:click="$refs.createTaskModal.show()"
          v-if="isAdmin || isPrinter"
        >
          打印
        </button>
        <button
          type="button"
          class="btn btn-sm btn-primary mx-2"
          v-on:click="printShippingTickets"
          v-if="isAdmin || isPrinter"
        >
          打印快递单
        </button>
        <button
          type="button"
          class="btn btn-sm btn-primary mx-2"
          v-on:click="exportSpreadsheet"
        >
          导出订单
        </button>
        <button
          type="button"
          class="btn btn-sm btn-primary mx-2"
          v-on:click="redownloadFiles"
          v-if="isAdmin"
        >
          重新下载
        </button>
        <button
          type="button"
          class="btn btn-sm btn-primary mx-2"
          v-on:click="preCreateShipNos"
          v-if="isAdmin || isPrinter"
        >
          批量生成快递单号
        </button>
      </span>
    </span>
    <form
      id="export-spreadsheet-form"
      enctype="multipart/form-data"
      method="post"
      action="/api/orders/spreadsheet"
    >
      <input type="hidden" name="name" />
      <input type="hidden" name="order_nos" />
    </form>

    <b-modal id="new-task" ref="createTaskModal" :hide-header="true">
      <form>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">任务名</label>
          <div class="col-sm-7">
            <input
              type="text"
              class="form-control"
              id="name"
              name="task-name"
              v-validate="'required'"
              :class="{ 'is-invalid': errors.has('task-name') }"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">任务类型</label>
          <div class="col-sm-7">
            <div class="form-check">
              <label class="form-check-label">
                <input
                  class="form-check-input"
                  type="radio"
                  name="task_type"
                  value="merge"
                  v-model="task_type"
                />
                合并选中订单文件到打印机目录
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input
                  class="form-check-input"
                  type="radio"
                  name="task_type"
                  value="copy"
                  v-model="task_type"
                />
                拷贝选中订单文件到打印机目录
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input
                  class="form-check-input"
                  type="radio"
                  name="task_type"
                  value="merge_stacked"
                  v-model="task_type"
                />
                合拼(产品页数固定时使用)
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input
                  class="form-check-input"
                  type="radio"
                  name="task_type"
                  value="merge_continus"
                  v-model="task_type"
                />
                叠拼(产品页数不同时使用)
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input
                  class="form-check-input"
                  type="radio"
                  name="task_type"
                  value="merge_sewing"
                  v-model="task_type"
                />
                锁线装拼板
              </label>
            </div>
          </div>
        </div>
      </form>
      <div slot="modal-footer" class="w-100">
        <button
          class="btn float-right mx-5"
          :class="{
            'btn-secondary': isSubmitting,
            'btn-primary': !isSubmitting
          }"
          @click="validateAndCreateTask"
          :disabled="isSubmitting"
        >
          提交
        </button>
        <button
          class="btn btn-secondary float-right"
          @click="$refs.createTaskModal.hide()"
        >
          取消
        </button>
      </div>
    </b-modal>

    <b-modal title="批量生成快递单号" size="lg" ref="createShipNosModal">
      <div class="form-group row">
        <label
          class="col-md-4 col-form-label"
          v-b-tooltip.hover
          title="使用哪种快递"
          >快递使用</label
        >
        <div class="col-md-8">
          <select
            class="custom-select"
            id="ship-company"
            v-model="shipNoCompany"
          >
            <option value="default">默认</option>
            <option value="yuantong">圆通</option>
            <option value="zhongtong">中通</option>
            <option value="youzheng">邮政快递包裹</option>
            <option value="youzhengbiaokuai">邮政国内标快</option>
            <option value="shentong">申通</option>
            <option value="yunda">韵达</option>
            <option value="shunfeng">顺丰</option>
          </select>
        </div>
      </div>
      <table class="table table-sm table-hover">
        <thead>
          <th>外部订单号</th>
          <th>状态</th>
          <th>旧快递单号</th>
          <th>新快递单号</th>
        </thead>
        <tbody>
          <tr v-for="order of shipNoOrders" :key="order.companyOrderNo">
            <td>{{ order.companyOrderNo }}</td>
            <td>{{ getOrderStatusDisplay(order.status) }}</td>
            <td>{{ order.shipNo }}</td>
            <td>{{ order.newShipNo }}</td>
          </tr>
        </tbody>
      </table>
      <div slot="modal-footer" class="w-100">
        <button
          class="btn float-right mx-5"
          :class="{
            'btn-secondary': isSubmitting,
            'btn-primary': !isSubmitting
          }"
          @click="postCreateShipNos"
          :disabled="isSubmitting"
        >
          生成快递单号
        </button>
        <button
          class="btn btn-secondary float-right"
          @click="$refs.createShipNosModal.hide()"
        >
          关闭
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
// 导出excel事件
import RoleMixin from "@/mixins/role";
import OrderMixin from "@/mixins/order";

function exportSpreadsheet() {
  let form = document.getElementById("export-spreadsheet-form");
  form
    .querySelector('input[name="name"]')
    .setAttribute("value", "export-order-spreadsheet");
  let orderNos = this.selectedIds;
  if (!orderNos || orderNos.length <= 0) {
    return;
  }
  form
    .querySelector('input[name="order_nos"]')
    .setAttribute("value", orderNos.join(","));
  form.submit();
}

function validateAndCreateTask() {
  this.$validator.validateAll().then(result => {
    if (!result) {
      return;
    }
    this.createTask();
  });
}

function createTask() {
  // make some changes to prevent from submitting requests twice
  if (this.isSubmitting) {
    return;
  }
  this.isSubmitting = true;
  let name = document.getElementById("name").value;

  let requestData = {
    order_nos: this.selectedIds,
    task_type: this.task_type,
    name: name
  };

  // validation
  if (!requestData.order_nos || requestData.order_nos.length === 0) {
    return;
  }
  this.$simpleHttp.post("/api/tasks/validate", requestData).then(response => {
    let data = response.data.data;
    if (data.in_tasks.length || data.in_revoked_tasks.length) {
      let message = `如下订单已经有拼板任务：\n${data.in_tasks.join(
        ","
      )}\n如下订单已经有拼板任务且任务已经被删除：\n${data.in_tasks.join(
        ","
      )}\n是否继续创建任务？`;
      let result = confirm(message);
      if (!result) {
        this.isSubmitting = false;
        return;
      }
    }

    if (
      data.product_names &&
      data.product_names.length > 1 &&
      requestData.task_type != "copy"
    ) {
      let message = `您提交的任务包含多个产品：${data.product_names.join(
        ","
      )}。是否继续创建任务？`;
      let result = confirm(message);
      if (!result) {
        this.isSubmitting = false;
        return;
      }
    }

    // create task
    this.$http.post("/api/tasks", requestData).then(response => {
      this.$refs.createTaskModal.hide();
      this.isSubmitting = false;
    });
  });
}

function preCreateShipNos() {
  // 查询订单， 如果订单已经有shipno，需要显示出来
  this.$refs.createShipNosModal.show();
  this.$http
    .get(`/api/orders`, {
      params: {
        order_no__in: this.selectedIds.join(","),
        size: 100
      }
    })
    .then(response => {
      let items = [];
      for (let item of response.data.data) {
        items.push({
          orderNo: item.order_no,
          companyOrderNo: item.order_no,
          status: item.status,
          shipNo: item.ship_no,
          newShipNo: ""
        });
      }
      this.shipNoOrders = items;
    });
}

async function postCreateShipNos() {
  const ok = confirm("确认批量生成快递单号吗？");
  if (!ok) {
    return;
  }

  if (this.shipNoCompany == "default") {
    alert("请选择用哪个快递");
    return;
  }

  for (let order of this.shipNoOrders) {
    const response = await this.$http.post(
      `/api/orders/${order.companyOrderNo}/ship_no`,
      {
        ship_company: this.shipNoCompany,
        enforce: true
      }
    );

    if (response.data.success) {
      order.newShipNo = response.data.data.ship_no;
    } else {
      order.newShipNo = "失败";
    }
  }
}

function redownloadFiles() {
  this.$http.post("/api/orders/action", {
    operation: "redownload",
    order_nos: this.selectedIds
  });
}

// 缺文件订单
function filterDownloadFailed() {
  let url = "/orders?status=download_failed";
  window.open(url, "_self");
}

// 打印快递单
function printShippingTickets() {
  let url = "/tickets?order_nos=" + this.selectedIds.join(",");
  window.open(url, "_blank");
}

export default {
  name: "orders-operation",
  props: ["selectedIds"],
  mixins: [RoleMixin, OrderMixin],
  data() {
    return {
      task_type: "merge",
      isSubmitting: false,
      shipNoOrders: [],
      shipNoCompany: "default"
    };
  },
  methods: {
    exportSpreadsheet,
    validateAndCreateTask,
    createTask,
    redownloadFiles,
    printShippingTickets,
    filterDownloadFailed,
    preCreateShipNos,
    postCreateShipNos
  }
};
</script>

<style lang="scss" scoped>
.orders-operation {
  display: inline-block;
}
</style>
